"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AllNodeMap = exports.AllNodes = void 0;
const AllNodes = __importStar(require("./AllNodes"));
exports.AllNodes = AllNodes;
/**
 * The AllNodeMap is a mapping of the node type names to the node classes that implement them.
 * The primary use for this is as a map of nodes to be used by design tools
 * This is also used by the executor to quickly find the class to instantiate, using just the NODE_TYPE name
 */
exports.AllNodeMap = Object.keys(AllNodes).reduce((acc, key) => {
    return Object.assign(Object.assign({}, acc), { [AllNodes[key].nodeDefinition.NODE_TYPE]: AllNodes[key] });
}, {});
//# sourceMappingURL=index.js.map